import { useEffect, useState } from "react";
import { api, API } from "./api";

let cache = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(cache));

export function refreshSiteAssets() {
    cache = null;
    inflight = null;
    listeners.forEach((fn) => fn(null));
}

export function useSiteAssets() {
    const [assets, setAssets] = useState(cache);

    useEffect(() => {
        listeners.add(setAssets);
        if (!cache && !inflight) {
            inflight = api
                .get("/site-assets")
                .then((res) => {
                    cache = res.data;
                    notify();
                })
                .catch(() => {
                    cache = { images: {}, profile: {} };
                    notify();
                });
        } else if (cache) {
            setAssets(cache);
        }
        return () => listeners.delete(setAssets);
    }, []);

    return assets || { images: {}, profile: {} };
}

export const siteImageUrl = (slot) => `${API}/site-assets/image/${slot}`;
